const BUILD_META_NAME = 'app-build-version';
const CHECK_INTERVAL_MS = 15 * 60 * 1000;
const EVENT_STORAGE_KEY = 'cnet-build-diagnostics';
const BANNER_ID = 'cnet-new-build-banner';
let checkInProgress = false;
let lastCheckAt = 0;

const getBuildVersion = documentToRead => {
	const meta = documentToRead.querySelector(`meta[name="${BUILD_META_NAME}"]`);
	const version = meta && meta.getAttribute('content');
	return version && version.indexOf('%') === -1 ? version : null;
};

const recordBuildEvent = (type, details = {}) => {
	const event = { type, timestamp: new Date().toISOString(), buildVersion: getBuildVersion(document) || 'unknown', pathname: window.location.pathname, online: navigator.onLine, ...details };
	try {
		const events = JSON.parse(sessionStorage.getItem(EVENT_STORAGE_KEY)) || [];
		events.push(event);
		sessionStorage.setItem(EVENT_STORAGE_KEY, JSON.stringify(events.slice(-20)));
	} catch (error) {
		// Diagnostics must not interrupt the app when browser storage is blocked.
	}
	if (typeof window.cnetBuildDiagnosticHandler === 'function') window.cnetBuildDiagnosticHandler(event);
};

const showNewBuildBanner = currentVersion => {
	if (document.getElementById(BANNER_ID)) return;
	const banner = document.createElement('div');
	banner.id = BANNER_ID;
	banner.setAttribute('role', 'alert');
	banner.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:2147483647;padding:12px 16px;background:#17365d;color:#fff;text-align:center;font-family:Arial,sans-serif;font-size:14px;box-shadow:0 2px 6px rgba(0,0,0,.25)';
	banner.appendChild(document.createTextNode('A new version of CustomerNet is available. '));
	const updateButton = document.createElement('button');
	updateButton.type = 'button';
	updateButton.textContent = 'Update now';
	updateButton.style.cssText = 'margin-left:8px;padding:5px 12px;cursor:pointer';
	updateButton.addEventListener('click', () => { recordBuildEvent('build_update_accepted', { currentVersion }); window.location.reload(); });
	const dismissButton = document.createElement('button');
	dismissButton.type = 'button';
	dismissButton.setAttribute('aria-label', 'Dismiss update notification');
	dismissButton.textContent = '\u00d7';
	dismissButton.style.cssText = 'position:absolute;right:12px;border:0;background:transparent;color:#fff;font-size:22px;cursor:pointer';
	dismissButton.addEventListener('click', () => { if (banner.parentNode) banner.parentNode.removeChild(banner); });
	banner.appendChild(updateButton);
	banner.appendChild(dismissButton);
	document.body.appendChild(banner);
};

export const checkForNewBuild = () => {
	const loadedVersion = getBuildVersion(document);
	if (!loadedVersion || checkInProgress) return Promise.resolve(false);
	checkInProgress = true;
	lastCheckAt = Date.now();
	return fetch(`/?buildCheck=${lastCheckAt}`, { cache: 'no-store', headers: { 'Cache-Control': 'no-cache' }, credentials: 'same-origin' })
		.then(response => { if (!response.ok) throw new Error(`Build check returned HTTP ${response.status}`); return response.text(); })
		.then(html => {
			const currentDocument = new DOMParser().parseFromString(html, 'text/html');
			const currentVersion = getBuildVersion(currentDocument);
			if (currentVersion && currentVersion !== loadedVersion) {
				recordBuildEvent('new_build_available', { loadedVersion, currentVersion });
				showNewBuildBanner(currentVersion);
				return true;
			}
			return false;
		})
		.catch(error => { recordBuildEvent('build_check_failed', { message: String(error && error.message || error).slice(0, 300) }); return false; })
		.then(result => { checkInProgress = false; return result; });
};

export const initializeBuildFreshness = () => {
	recordBuildEvent('application_loaded');
	window.addEventListener('error', event => {
		const target = event.target;
		if (target && target !== window && (target.tagName === 'SCRIPT' || target.tagName === 'LINK')) {
			const assetUrl = target.src || target.href || '';
			recordBuildEvent('asset_load_failed', { assetType: target.tagName.toLowerCase(), assetUrl: assetUrl.split('?')[0].split('#')[0] });
		}
	}, true);
	window.addEventListener('focus', () => { if (Date.now() - lastCheckAt >= CHECK_INTERVAL_MS) checkForNewBuild(); });
	window.setInterval(checkForNewBuild, CHECK_INTERVAL_MS);
};



// WEBPACK FOOTER //
// ./src/App/diagnostics/buildFreshness.js